import { jsx as _jsx } from "react/jsx-runtime";
import { List, ListItem, ListItemText } from '@mui/material';
import { isSameDay } from 'date-fns';
const isSameRange = (first, second) => {
    const { startDate: fStart, endDate: fEnd } = first;
    const { startDate: sStart, endDate: sEnd } = second;
    if (fStart && sStart && fEnd && sEnd) {
        return isSameDay(fStart, sStart) && isSameDay(fEnd, sEnd);
    }
    return false;
};
const DefinedRanges = ({ ranges, setRange, selectedRange, }) => (_jsx(List, { children: ranges.map((range, idx) => (_jsx(ListItem, { button: true, onClick: () => setRange(range), children: _jsx(ListItemText, { primaryTypographyProps: {
                variant: 'body2',
                style: {
                    fontWeight: isSameRange(range, selectedRange) ? 'bold' : 'normal',
                },
            }, children: range.label }) }, idx))) }));
export default DefinedRanges;
